<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="toct"><a id="page_vii"></a><a href="#/xhtml/08_Acknowledgement">Acknowledgments</a></p>
<p class="toct"><a href="#/xhtml/10_Introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/11_Chapter01"><b>1</b>  Exemplarity and the German-Jewish Symbiosis: Hermann Cohen on War and Religion</a></p>
<p class="toc"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample"><b>2</b>  Symbol Not Sacrifice: Cohen’s Jewish Jesus</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample"><b>3</b>  Fire, Rays, and the Dark: Rosenzweig and the Oriental/Occidental Divide</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample"><b>4</b>  Redeeming This World: Buber’s Judaism and the Sanctity of Immanence</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample"><b>5</b>  Prophets, Prophecy, and Divine Wrath: Heschel and the God of Pathos</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter06" title="Link target outside of Sample"><b>6</b>  Cultivating Objectivity: Soloveitchik, the Marburg School, and Religious Pluralism</span></p>
<p class="toct"><span href="#/xhtml/17_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toca"><span href="#/xhtml/18_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toca"><span href="#/xhtml/19_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?acdde69e